module.exports = __webpack_public_path__ + "img/pro_info.ae1c4199.png";